import Api from 'utils/Api'
import ApiCalendar from 'utils/ApiCalendar'

class AdventureService {

  // getCategories() {
  //   return Api.call('/category-type', 'get')
  //     .then(res => res.data)
  //     .catch(err => { throw err })
  // }

  getRequestCustomFields(pkAdventure) {
    return Api.call('/adventure/get-request-custom-fields', 'get', { pkAdventure })
      .then(res => res.data)
      .catch(err => { throw err })
  }

  removeRequestCustomField(params) {
    return Api.call('/adventure/delete-request-custom-fields', 'delete', params)
    .then(res => res.data)
    .catch(err => { throw err })
  }

  insertRequestCustomFields(params) {
    return Api.call('/adventure/upsert-request-custom-fields', 'post', params, false, true)
    .then(res => res.data)
    .catch(err => { throw err })
  }

  getReserveCustomFields(pkAdventure) {
    return Api.call('/adventure/get-reserve-custom-fields', 'get', { pkAdventure })
      .then(res => res.data)
      .catch(err => { throw err })
  }

  removeReserveCustomField(params) {
    return Api.call('/adventure/delete-reserve-custom-fields', 'delete', params)
    .then(res => res.data)
    .catch(err => { throw err })
  }

  insertReserveCustomFields(params) {
    return Api.call('/adventure/upsert-reserve-custom-fields', 'post', params, false, true)
    .then(res => res.data)
    .catch(err => { throw err })
  }

  getCategories() {
    return Api.call('/category/get-categories', 'get', {withNoAdventures: true})
      .then(res => res.data)
      .catch(err => { throw err })
  }

  getTypesByCategoriesId(categoryTypeId) {
    return Api.call('/type/get-by-category-type', 'get', { pkCategoryType: categoryTypeId })
      .then(res => res.data)
      .catch(err => { throw err })
  }

  uploadImageToAws(data, progress) {
    return Api.call(`/image/save-image`, 'post', data, false, true, progress )
      .then(res => res.data)
      .catch(err => { throw err })
  }

  saveDraft(adventure, progress) {
    return Api.call('/adventure/create-adventure', 'post', { adventure }, false, true, progress)
      .then(res => res.data)
      .catch(err => { throw err })
  }

  deleteAdventure(pkAdventure) {
    return Api.call('/adventure/remove-adventure', 'post', { pkAdventure }, false, true)
      .then(res => res.data)
      .catch(err => { throw err })
  }

  getAdventuresByCompany() {
    return Api.call('/adventure/get-adventure-by-company-independ-of-status', 'get')
      .then(res => res.data)
      .catch(err => { throw err })
  }

  getAdventureById(pkAdventure) {
    return Api.call('/adventure/get-adventure-by-id', 'get', { pkAdventure })
      .then(res => res.data)
      .catch(err => { throw err })
  }

  changeStatusToAnalyze(pk_adventure) {
    return Api.call('/adventure/change-status-to-analyze', 'post', { pk_adventure })
      .then(res => res.data)
      .catch(err => { throw err })
  }

  changeStatusToDisabled(pk_adventure) {
    return Api.call('/adventure/change-status-to-disabled', 'post', { pk_adventure })
      .then(res => res.data)
      .catch(err => { throw err })
  }

  changeStatusToEnabled(pk_adventure) {
    return Api.call('/adventure/change-status-to-enabled', 'post', { pk_adventure })
      .then(res => res.data)
      .catch(err => { throw err })
  }

  update(adventure, progress) {
    return Api.call('/adventure/create-adventure', 'post', { adventure }, false, true, progress)
      .then(res => res.data)
      .catch(err => { throw err })
  }

  updatePackage(params) {
    return Api.call('/adventure/update-package', 'post', params, false, true)
      .then(res => res.data)
      .catch(err => { throw err })
  }

  updateOperatings(params) {
    return Api.call('/adventure/update-operating', 'post', params, false, true)
      .then(res => res.data)
      .catch(err => { throw err })
  }

  createSchedule(params) {
    return Api.call('/schedule-rule/create-schedule-rule', 'post', params, false, true)
    .then(res => res.data)
    .catch(err => {throw err})
  }

  deleteScheduleRule(params) {
    return Api.call('/schedule-rule/delete-schedule-rule', 'post', params, false, true)
    .then(res => res.data)
    .catch(err => { throw err });
  }

  saveCalendar(params) {
    return ApiCalendar.call('/create-calendar', 'post', params)
      .then(res => res.data)
      .catch(err => { throw err })
  }

  setAdventureCalendarId(params) {
    return Api.call('/adventure/set-calendar-id', 'post', params, false, true)
      .then(res => res.data)
      .catch(err => { throw err })
  }
}

export default new AdventureService();


// WEBPACK FOOTER //
// ./src/services/AdventureService.js